import { SampleRepository } from '@telespot/domain';

export interface ICountSamplesByMethodTypeQuery {
  /**
   * Counts samples that reference the given method type.
   * Repository errors propagate so the caller can apply its own fallback.
   */
  execute(methodTypeId: string): Promise<number>;
}

export class CountSamplesByMethodTypeQuery implements ICountSamplesByMethodTypeQuery {
  constructor(private readonly sampleRepository: SampleRepository) {}

  public async execute(methodTypeId: string): Promise<number> {
    return this.sampleRepository.countByMethodType(methodTypeId);
  }
}
